import {
  AutodataCustomEventTypes,
  AlgoliaRequestSuccessEvent,
} from "./ts/types";

export default (autoData: AutoData): DisposableApp => {
  const onAlgoliaRequestSuccessAutodataHandler = ({
    detail: { dataEvent },
  }: AlgoliaRequestSuccessEvent) => {
    autoData.sendEvent(dataEvent);
  };

  window.addEventListener(
    AutodataCustomEventTypes.ON_ALGOLIA_REQUEST_SUCCESS,
    onAlgoliaRequestSuccessAutodataHandler as EventListener
  );

  return function disposeCallback() {
    window.removeEventListener(
      AutodataCustomEventTypes.ON_CLICK_RESULT,
      onAlgoliaRequestSuccessAutodataHandler as EventListener
    );
  };
};
